module.exports = __webpack_public_path__ + "static/media/mail.6e0a0c28.svg";